import $ from "jquery";

import quilterFunctions from "../helpers/quilter-functions";

function init(): void {
  const $modalTrigger = $(".js-modal-trigger");
  $modalTrigger.off();

  const updateModalBodyMargin = (el, headingHeight: number) => {
    el.css("maxHeight", `calc(80vh - ${headingHeight}px)`); // we could use class names, but this feels easier to manage if header sizing changes in the future
  };

  const updateModalBodyInner = () => {
    const $modalHeader = $(".js-modal-header");
    const $modalBodyInner = $(".js-modal-body-inner");
    if ($modalHeader.length && $modalBodyInner.length) {
      $modalBodyInner.each(function () {
        const $this = $(this);
        if ($this.is(":visible")) {
          const headerId = $this.data("headerId");
          const headerH = $(`#${headerId}`).outerHeight();
          updateModalBodyMargin($this, headerH);
        }
      });
    }
  };

  $(window).on("resize orientationchange", updateModalBodyInner);
  document.addEventListener("QuilterModal", () => {
    updateModalBodyInner();
  });

  $(document).on("click", ".js-modal-trigger", function (e) {
    e.preventDefault();
    const targetModal = $(e.currentTarget).data("target");
    quilterFunctions.openModal(targetModal);
    updateModalBodyInner();
  });

  function closeModal() {
    quilterFunctions.closeModal(".js-modal");
  }

  $(".js-modal-close").click(closeModal);

  $(".js-modal-overlay-closeable").click(function (e) {
    if ($(e.target).hasClass("js-modal-close")) {
      // If we've clicked directly on the overlay, and not an inner element that happens to trigger the event...
      // Close the modal
      closeModal();
    } else {
      // Do nothing, because this is likely a click event triggered by an element inside the modal, not directly on the overlay
    }
  });

  if ($(".js-modal-open").length) {
    quilterFunctions.openModal(".js-modal-open");
  }

  updateModalBodyInner();
}

export default { init };
